import React, { useState } from 'react';
import './index.scss';
interface NodeItemState {
  operationType: string;
  operationTime: string;
  operationDescription: string;
  keyOperation: boolean;
}
interface TimeBarProps {
  list: NodeItemState[];
}
const TimeLine = (props: TimeBarProps) => {
  const { list } = props;
  return (
    <>
      <ul className='time-bar-wrapper'>
        {list.map((item, index) => (
          <li className='time-bar-item' key={index}>
            <span style={{ marginRight: '12px', marginTop: '-7px' }}>
              {item.operationTime}
            </span>
            <div className='icon-wrapper'>
              {item.keyOperation ? (
                <div className='circle-point-key' />
              ) : (
                <div className='circle-point' />
              )}
              <div className='border-image' />
            </div>
            <div className='info-content'>
              <div style={{ display: 'flex' }}>
                <span className='high-light'>{item.operationType}</span>
              </div>
              <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                {item.operationDescription}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};

export default TimeLine;
